/**
 * Theme Initialization Script
 * Handles AOS (Animate On Scroll) and Parallax initialization
 */
document.addEventListener("DOMContentLoaded", function () {
  if (window.AOS) {
    AOS.init({
      easing: 'ease',
      once: true,
      duration: 1000,
      offset: 60
    });

    setTimeout(function () {
      AOS.refresh();
    }, 1000);
  }

  if (window.universalParallax) {
    new universalParallax().init({
      speed: 10
    });
  }

});

